<template>
  <div>
    <header class="modal-header">
      <img
        slot="close"
        class="modal-close"
        @click="close"
        src="/assets/icon/icon-close.svg"
      >
      {{ $t('Register') }}
    </header>

    <div class="modal-content pt30 pb60 px65 cl-secondary">
      <form @submit.prevent="register" novalidate>
        <base-input
          type="email"
          name="email"
          autocomplete="email"
          v-model="email"
          @blur="$v.email.$touch()"
          focus
          :placeholder="$t('E-mail address *')"
          :validations="[
            {
              condition: !$v.email.required && $v.email.$error,
              text: $t('Field is required.')
            },
            {
              condition: !$v.email.email && $v.email.$error,
              text: $t('Please provide valid e-mail address.')
            }
          ]"
        />
        <div class="row">
          <base-input
            class="col-xs-6"
            type="text"
            name="first-name"
            autocomplete="given-name"
            v-model="firstName"
            @blur="$v.firstName.$touch()"
            :placeholder="$t('First name *')"
            :validations="[
              {
                condition: !$v.firstName.required && $v.firstName.$error,
                text: $t('Field is required.')
              },
              {
                condition: !$v.firstName.minLength,
                text: $t('Name must have at least 2 letters.')
              }
            ]"
          />
          <base-input
            class="col-xs-6"
            type="text"
            name="last-name"
            autocomplete="last-name"
            v-model="lastName"
            @blur="$v.lastName.$touch()"
            :placeholder="$t('Last name *')"
            :validations="[{
              condition: !$v.lastName.required && $v.lastName.$error,
              text: $t('Field is required.')
            }]"
          />
        </div>
        <base-input
          type="password"
          name="password"
          ref="password"
          autocomplete="new-password"
          v-model="password"
          @blur="$v.password.$touch()"
          :placeholder="$t('Password *')"
          :validations="[
            {
              condition: !$v.password.required && $v.password.$error,
              text: $t('Field is required.')
            },
            {
              condition: !$v.password.minLength && $v.password.$error,
              text: $t('Password must have at least 8 letters.')
            }
          ]"
        />
        <base-input
          type="password"
          name="password-confirm"
          autocomplete="new-password"
          v-model="rPassword"
          @blur="$v.rPassword.$touch()"
          :placeholder="$t('Repeat password *')"
          :validations="[
            {
              condition: !$v.rPassword.required && $v.rPassword.$error,
              text: $t('Field is required.')
            },
            {
              condition: !$v.rPassword.sameAsPassword && $v.rPassword.$error,
              text: $t('Passwords must be identical.')
            }
          ]"
        />
        <div class="options">
          <base-checkbox
            id="terms"
            v-model="conditions"
            @blur="$v.conditions.$reset()"
            @change="$v.conditions.$touch()"
            :validations="[{
              condition: !$v.conditions.required && $v.conditions.$error,
              text: $t('You must accept the terms and conditions.')
            }]"
          >
            Ich akzeptiere die
            <router-link
              to="/agb"
              title="Zu den Allgemeinen Geschäftsbedingungen"
              class="register-terms-link"
              @click.native.stop="close"
            >
              Allgemeinen Geschäftsbedingungen
            </router-link>
            *
          </base-checkbox>
        </div>
        <button-full class="btn btn-primary" type="submit">
          {{ $t('Register an account') }}
        </button-full>
        <span class="link-alt">
          {{ $t('or') }}
          <a href="#" @click.prevent="switchElem">
            {{ $t('login to your account') }}
          </a>
        </span>
      </form>
    </div>
  </div>
</template>
<script>
import Register from '@vue-storefront/core/compatibility/components/blocks/Auth/Register'
import ButtonFull from 'theme/components/theme/ButtonFull.vue'
import BaseCheckbox from 'theme/components/core/blocks/Form/BaseCheckbox.vue'
import BaseInput from 'theme/components/core/blocks/Form/BaseInput.vue'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
  validations: {
    email: {
      required,
      email
    },
    firstName: {
      minLength: minLength(2),
      required
    },
    lastName: {
      required
    },
    password: {
      minLength: minLength(8),
      required
    },
    rPassword: {
      required,
      sameAsPassword: sameAs('password')
    },
    conditions: {
      required
    }
  },
  mixins: [Register],
  components: {
    ButtonFull,
    BaseCheckbox,
    BaseInput
  },
  methods: {
    register () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('Please fix the validation errors'),
          action1: { label: this.$t('OK') }
        })
        return
      }

      const siteKey = '6Lel44YqAAAAAKQD4tBMupkSzc3EGe21O5QCjM-q';
      this.addRecaptcha(siteKey, () => {
        this.getRecaptchaToken(siteKey, (token) => {
          this.callRegister(token)
        });
      });
    },
    onSuccess () {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'success',
        message: this.$t('You are logged in!'),
        action1: { label: this.$t('OK') }
      })
    },
    onFailure (result) {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message: this.$t(result.result),
        action1: { label: this.$t('OK') }
      })
    },
    addRecaptcha (siteKey, callback) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;
      script.onload = callback;
      document.head.appendChild(script);
    },
    getRecaptchaToken (siteKey, callback) {
      const grecaptcha = window.grecaptcha;
      grecaptcha.ready(() => {
        grecaptcha.execute(siteKey, { action: 'submit' }).then((token) => {
          callback(token);
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .register-terms-link {
    text-decoration: underline;
  }

  .modal-content {
    @media (max-width: 400px) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
</style>
